/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media only screen and (max-width:991px){form[_ngcontent-%COMP%]   .one-field[_ngcontent-%COMP%]{margin-bottom:0}}"];
export { styles as styles };
